/**
 * The icon and colour choices the entry-type settings page offers.
 *
 * A curated shortlist rather than free text or the whole 250-icon set. `icon` is a
 * plain string column on `company_diary_entry_types`, so anything the form writes
 * is rendered verbatim by `SvgIcon` - and a name with no matching symbol renders as
 * nothing at all, silently, on every entry filed under that type. A picker cannot
 * produce one.
 *
 * The defaults the platform seeds are all in this list, so opening an untouched
 * system type shows its own icon selected rather than a blank picker.
 */

export interface CompanyDiaryIconOption {
    name: string;
    label: string;
}

export const COMPANY_DIARY_ICONS: CompanyDiaryIconOption[] = [
    { name: 'system-staff', label: 'Staff' },
    { name: 'system-user-outline', label: 'Person' },
    { name: 'system-two-people', label: 'Team' },
    { name: 'system-tools', label: 'Tools' },
    { name: 'system-toolbox', label: 'Toolbox' },
    { name: 'system-spanner', label: 'Spanner' },
    { name: 'system-truck', label: 'Truck' },
    { name: 'system-trailer', label: 'Trailer' },
    { name: 'system-container', label: 'Container' },
    { name: 'system-policy', label: 'Compliance' },
    { name: 'system-shield-outline', label: 'Shield' },
    { name: 'system-document', label: 'Document' },
    { name: 'system-box-outline', label: 'Box' },
    { name: 'system-stacked-boxes-outline', label: 'Supplies' },
    { name: 'system-warning', label: 'Warning' },
    { name: 'system-alert', label: 'Alert' },
    { name: 'system-fire', label: 'Fire' },
    { name: 'system-medical-mask', label: 'Health' },
    { name: 'system-calendar', label: 'Calendar' },
    { name: 'system-clock-in', label: 'Clock' },
    { name: 'system-list', label: 'List' },
    { name: 'system-flag', label: 'Flag' },
    { name: 'system-depot', label: 'Depot' },
    { name: 'system-warehouse', label: 'Warehouse' },
];

/**
 * Calendar-legible hues, one per family, spaced far enough apart that two types
 * side by side on a month grid are told apart at a glance. The seeded defaults use
 * these values.
 */
export const COMPANY_DIARY_COLOURS: string[] = [
    '#6366F1',
    '#8B5CF6',
    '#EC4899',
    '#DC2626',
    '#EF4444',
    '#F59E0B',
    '#EAB308',
    '#22C55E',
    '#14B8A6',
    '#0EA5E9',
    '#3B82F6',
    '#64748B',
];

/** The colour an entry renders in when its type carries none. */
export const COMPANY_DIARY_FALLBACK_COLOUR = '#64748B';

/** The icon an entry renders with when its type carries none, or an unknown one. */
export const COMPANY_DIARY_FALLBACK_ICON = 'system-calendar';
